module.exports = __webpack_public_path__ + "static/media/0_2019_07_06.086c7fc6.jpg";